import { print } from 'graphql';
import { gql } from 'graphql-tag';

import { AdditionalFields } from '../common.types';
import { getDateModified, getRoleForMutation } from '../../utilities/utilityFunctions';
import { defaultDoc, getValueFromLocalStorage } from '../share/defaultDoc';
import type { InspectionFiles, InspectionFilesDocument } from './inspectionFiles.types';

export const inspectionFilesPullQueryBuilder = (document: InspectionFiles) => {
  let doc = document;
  if (!doc) {
    (doc as unknown) = { ...defaultDoc };
  }

  const query = print(gql`
    query inspectionFilesFeed(
      $siteId: Int!
      $disciplineId: Int!
      $lastModified: DateTime!
      $isLeadInspector: Boolean!
    ) {
      inspectionFilesFeed(
        siteId: $siteId
        disciplineId: $disciplineId
        lastModified: $lastModified
        isLeadInspector: $isLeadInspector
      ) {
        fileId
        name
        fileUUID
        originalFileName
        originalPath
        legacyId
        isImageFile
        inspectionId
        showOnReport
        fileDescription
        drawingType
        fileCategory
        pcsId
        fkAimsfileTblSp
        sizeMb
        allowSpaccess
        siteId
        disciplineId
        userCreated
        userModified
        extension
        dateCreated
        dateModified
        isDelete
        fkAssetInspectionTask
        fkInspectorField
        fkInspectorLead
        fileSortOrder
      }
    }
  `);
  return {
    query,
    variables: {
      siteId: JSON.parse(getValueFromLocalStorage('selectedSite'))?.selectedSiteId,
      disciplineId: JSON.parse(getValueFromLocalStorage('selectedDiscipline'))
        ?.selectedDisciplineId,
      lastModified: getDateModified(
        doc?.dateModified,
        doc?.dateCreated,
        doc.siteId,
        doc.disciplineId,
        JSON.parse(getValueFromLocalStorage('selectedSite'))?.selectedSiteId,
        JSON.parse(getValueFromLocalStorage('selectedDiscipline'))?.selectedDisciplineId,
      ),
      isLeadInspector: getValueFromLocalStorage('isLeadInspector') === 'True',
    },
  };
};

export const inspectionFilesPushQueryBuilder = (doc: InspectionFiles[]) => {
  const document = doc[0];
  const query = print(gql`
    mutation cEDInspectionFileInfo(
      $role: Int!
      $MobileInspectionFilesFeedInput: MobileInspectionFilesFeedInput
    ) {
      cEDInspectionFileInfo(role: $role, inspectionFileRequest: $MobileInspectionFilesFeedInput) {
        fileId
        uUID
        inspectionId
        result
      }
    }
  `);

  const role = getRoleForMutation(document);

  const MobileInspectionFilesFeedInput = {
    ...document,
    fkInspectorField: document.fkInspectorField || 0,
    fkInspectorLead: document.fkInspectorLead || 0,
  };

  const variables = {
    MobileInspectionFilesFeedInput,
    role,
  };

  return {
    query,
    variables,
  };
};

export const inspectionFilesPushModifier = (doc: InspectionFilesDocument) => {
  const obj: AdditionalFields = {
    ...doc,
  };

  const blackListedProp = ['_meta', 'isDeleted'];
  blackListedProp.forEach(property => {
    obj[property as keyof AdditionalFields] = undefined;
  });

  return obj;
};
